import React, { useEffect, useState } from "react";
import UserProfilePicture from "../../../assets/dummy.png";
import axios from "axios";
import { BASE_URL } from "../../../Utlils";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import { TiCamera } from "react-icons/ti";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import Required from "../../../components/Required";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 361,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
};

const MyProfile = ({ user }) => {
  const { setSnackbar, organization, getCountries, getAllCountryStates } =
    useGlobalContext();
  const [inputData, setInputData] = useState({});
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [selectedFile, setSelectedFile] = useState();
  const [countryState, setCountryState] = useState({
    country: [],
    countryLoading: true,
    states: [],
    statsLoading: false,
  });
  const getCountry = async () => {
    try {
      let data = await getCountries();
      setCountryState((prev) => ({
        ...prev,
        country: data,
        countryLoading: false,
      }));
      if (inputData?.personalDetails?.countryCode) {
        let states = await getAllCountryStates(
          inputData?.personalDetails?.countryCode
        );
        setCountryState((prev) => ({
          ...prev,
          states: states,
          statsLoading: false,
        }));
      }
    } catch (error) {
      setCountryState((prev) => ({ ...prev, countryLoading: false }));
    }
  };
  useEffect(() => {
    setInputData(user);
  }, [Object.keys(user)?.length]);
  useEffect(() => {
    getCountry();
  }, [inputData?.personalDetails?.countryCode]);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BASE_URL}/users?id=${user?._id}`, {
        ...inputData,
      });

      if (organization?.name !== inputData?.organizationName) {
        await axios.put(`${BASE_URL}/company/${user?.organizationId}`, {
          name: inputData?.organizationName,
        });
      }
      setSnackbar((prev) => ({
        msg: "Profile Updated Successfully !",
        open: true,
        severity: "success",
      }));
    } catch (error) {
      console.log(error);
      setSnackbar({
        msg: `Something went wrong !`,
        open: true,
        severity: "error",
      });
    }
  };
  const uploadProfile = async (e) => {
    e.preventDefault();
    try {
      if (!selectedFile) {
        setSnackbar({
          open: true,
          msg: "Please select a file",
          severity: "error",
        });

        return;
      }
      const fileSizeInBytes = selectedFile.size;
      const maxSizeInBytes = 3 * 1024 * 1024; // 3 MB

      if (fileSizeInBytes > maxSizeInBytes) {
        setSnackbar({
          open: true,
          msg: `File size exceeds 3 MB limit`,
          severity: "error",
        });
        setProfileImage("");
        return;
      }
      setEditProfileModal(false);
      const formData = new FormData();
      formData.append("file", selectedFile);
      const uploadResponse = await axios.post(
        `${BASE_URL}/upload/file?id=${user?._id}&path=profile-pictures/${user?.organizationName}/${user?._id}.jpeg`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const avatarUrl = uploadResponse.data.url;
      await axios.put(`${BASE_URL}/users?id=${user?._id}`, {
        avatar: avatarUrl,
      });
      setSnackbar({
        open: true,
        msg: "File uploaded successfully",
        severity: "success",
      });
      window.location.reload();
    } catch (error) {
      console.error("Error uploading file:", error);

      setSnackbar({
        open: true,
        msg: "Error uploading file! Please try again.",
        severity: "error",
      });
    }
  };

  // console.log(selectedFile);
  // console.log("inputData=>", inputData);
  // console.log("user=>", user);
  // console.log(countryState);
  return (
    <div className="w-full flex flex-col gap-8 h-full overflow-auto hideScroll py-5">
      <div className="pb-6 border-b border-gray-200">
        <h1 className="text-[#0226BE] text-[28px] font-[600] mb-2">My Profile</h1>
        <p className="text-gray-600 text-[14px]">Manage your personal information and account settings</p>
      </div>
      <div className="flex items-center gap-6">
        <div className="w-[180px] h-[180px] bg-gradient-to-br from-[#0226BE] to-[#021ea8] rounded-full flex items-center justify-center relative shadow-md">
          <div className="w-[168px] h-[168px] bg-white rounded-full flex items-center justify-center">
            <img
              src={user?.avatar ? user?.avatar : UserProfilePicture}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = UserProfilePicture;
              }}
              alt=""
              className="w-[165px] h-[165px] rounded-full object-cover flex items-center justify-center"
            />
          </div>
          <div
            className="w-[40px] h-[40px] rounded-full absolute flex items-center justify-center bg-[#0226BE] bottom-[10%] right-[0%] cursor-pointer hover:bg-[#021ea8] transition-colors shadow-lg"
            onClick={(e) => {
              setEditProfileModal(true);
            }}
          >
            <TiCamera color="white" size={22} />
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h1 className="text-[#1a1a1a] text-[24px] font-[600]">
            {user?.personalDetails?.fullName}
          </h1>
          <p className="text-gray-600 text-[16px] font-[400]">
            Manage your profile information and preferences
          </p>
        </div>
      </div>
      <form
        className="flex flex-col gap-6 w-full pb-5"
        onSubmit={handleSubmit}
      >
        <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-6">
          <div className="space-y-2">
            <label className="text-[#1a1a1a] font-[500] text-[14px] flex items-center gap-1">
              Organization Name <Required />
            </label>
            <input
              type="text"
              required
              name="organizationName"
              value={inputData?.organizationName}
              onChange={handleChange}
              className={`w-full border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 placeholder:text-gray-400 ${
                user?.role === "admin" ? "" : "bg-gray-50 cursor-not-allowed"
              }`}
              disabled={user?.role === "admin" ? false : true}
            />
          </div>
          <div className="space-y-2">
            <label className="text-[#1a1a1a] font-[500] text-[14px] flex items-center gap-1">
              Full Name <Required />
            </label>
            <input
              type="text"
              required
              value={inputData?.personalDetails?.fullName}
              onChange={(e) => {
                if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                  setInputData((prev) => ({
                    ...prev,
                    personalDetails: {
                      ...prev?.personalDetails,
                      fullName: e.target.value,
                    },
                  }));
                }
              }}
              className="w-full border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 placeholder:text-gray-400"
            />
          </div>
          <div className="space-y-2">
            <label className="text-[#1a1a1a] font-[500] text-[14px]">
              Date of Birth
            </label>
            <input
              type="date"
              value={inputData?.personalDetails?.DOB}
              onChange={(e) =>
                setInputData((prev) => ({
                  ...prev,
                  personalDetails: {
                    ...prev?.personalDetails,
                    DOB: new Date(e.target.value)?.toLocaleDateString("en-ca"),
                  },
                }))
              }
              className="w-full border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400"
            />
          </div>
          <div className="space-y-2">
            <label className="text-[#1a1a1a] font-[500] text-[14px]">
              Contact Number
            </label>
            <input
              type="number"
              value={inputData?.personalDetails?.contactNo || ""}
              required
              title="Phone Number must 10 to 15 digit"
              onChange={(e) =>
                setInputData((prev) => ({
                  ...prev,
                  personalDetails: {
                    ...prev?.personalDetails,
                    contactNo: e.target.value,
                  },
                }))
              }
              className="w-full border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 placeholder:text-gray-400"
              placeholder="Enter phone number"
            />
          </div>
          <div className="space-y-2">
            <label className="text-[#1a1a1a] font-[500] text-[14px]">
              Location
            </label>
            <div className="flex items-center gap-4">
              <select
                name="country"
                id="country"
                className="flex-1 border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-10 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat cursor-pointer"
                value={inputData?.personalDetails?.countryCode}
                onChange={async (e) => {
                  setInputData((prev) => ({
                    ...prev,
                    personalDetails: {
                      ...prev?.personalDetails,
                      country: e.target.options[e.target.selectedIndex].text,
                      countryCode: e.target.value,
                      state: "",
                    },
                  }));
                  let states = await getAllCountryStates(e.target.value);
                  setCountryState((prev) => ({ ...prev, states: states }));
                }}
              >
                <option value="">Select Country</option>
                {countryState?.countryLoading ? (
                  <option value="" disabled>
                    Loading Country..
                  </option>
                ) : (
                  countryState?.country?.map((d, i) => (
                    <option value={d?.iso2} key={i}>
                      {d?.name}
                    </option>
                  ))
                )}
              </select>

              <select
                name="state"
                id="state"
                value={inputData?.personalDetails?.state}
                className="flex-1 border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-10 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22currentColor%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22%3e%3cpolyline points=%226 9 12 15 18 9%22%3e%3c/polyline%3e%3c/svg%3e')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat cursor-pointer"
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setInputData((prev) => ({
                      ...prev,
                      personalDetails: {
                        ...prev?.personalDetails,
                        state: e.target.value,
                      },
                    }));
                  }
                }}
              >
                <option value="">Select State</option>
                {countryState?.statsLoading ? (
                  <option value="" disabled>
                    Loading States..
                  </option>
                ) : countryState?.states?.length ? (
                  countryState?.states?.map((d, i) => (
                    <option value={d?.name} key={i}>
                      {d?.name}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    No States found try changing the country
                  </option>
                )}
              </select>
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-end gap-3">
          <button
            className="text-[#0226BE] border-2 border-[#0226BE] rounded-md px-6 py-2.5 text-[14px] font-[500] hover:bg-blue-50 transition-colors"
            type="button"
          >
            Cancel
          </button>
          <button
            className="bg-[#0226BE] text-white px-6 py-2.5 rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors"
            type="submit"
          >
            Save Changes
          </button>
        </div>
      </form>

      {/* EDIT PROFILE MODAL */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={editProfileModal}
        onClose={(e) => {
          setEditProfileModal(false);
          setProfileImage("");
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={editProfileModal}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col bg-white rounded-lg">
              <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative">
                <h1 className="text-[#0226BE] text-[20px] font-[600]">
                  Change Profile Picture
                </h1>
                <button
                  className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                  onClick={(e) => {
                    setEditProfileModal(false);
                    setProfileImage("");
                  }}
                >
                  <RxCross2 size={18} className="text-gray-600" />
                </button>
              </div>

              <div className="flex flex-col p-6 gap-6 justify-center items-center">
                <div className="flex flex-col h-[244px] w-[313px] justify-center items-center border-2 border-dashed border-gray-300 rounded-lg bg-gray-50">
                  <div className="flex w-[200px] h-[200px] rounded-full justify-center items-center overflow-hidden">
                    <img
                      src={
                        profileImage === ""
                          ? user?.avatar
                            ? user?.avatar
                            : UserProfilePicture
                          : profileImage
                      }
                      className="w-[200px] h-[200px] rounded-full object-cover"
                      alt="Profile preview"
                    />
                  </div>
                </div>
                <div className="w-full flex flex-col gap-3">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    id="file"
                    name="file"
                    onChange={(e) => {
                      handleFileChange(e);
                      setProfileImage(URL.createObjectURL(e.target.files[0]));
                    }}
                  />
                  {!profileImage ? (
                    <label
                      htmlFor="file"
                      className="w-full cursor-pointer h-[44px] px-4 py-2 bg-[#0226BE] rounded-md flex justify-center items-center text-white font-[500] hover:bg-[#021ea8] transition-colors"
                    >
                      Select Image
                    </label>
                  ) : (
                    ""
                  )}
                  {profileImage ? (
                    <button
                      className="w-full h-[44px] px-4 py-2 bg-[#0226BE] rounded-md flex justify-center items-center text-white font-[500] hover:bg-[#021ea8] transition-colors"
                      onClick={(e) => uploadProfile(e)}
                    >
                      Upload Image
                    </button>
                  ) : (
                    ""
                  )}
                  <button
                    className="w-full h-[44px] px-4 py-2 border-2 border-gray-300 rounded-md flex justify-center items-center text-gray-700 font-[500] hover:bg-gray-50 transition-colors"
                    onClick={(e) => {
                      setEditProfileModal(false);
                      setProfileImage("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              {/* <form
                className="w-full py-4 px-5  flex flex-col gap-[19px]"
                // onSubmit={(e) => {
                //   e.preventDefault();
                //   setModals((prev) => ({
                //     ...prev,
                //     changeEmail: false,
                //     openEmail: true,
                //   }));
                //   console.log(
                //     `${window.location.origin}/verify-change-email?oe=${user?.email}&ne=${changeEmail}&id=${user?._id}`
                //   );
                // }}
              >
                <div className="flex flex-col gap-[10px]">
                  <p className="text-[#333] text-[16px] font-[400]">
                    If you want to change your e-mail, verify it here{" "}
                  </p>
                  <p className="text-[#333] text-[14px] font-[500]">
                    Previous Email :
                  </p>
                </div>
                <div className="flex flex-col gap-[10px]">
                  <label
                    htmlFor="email"
                    className="text-[#333] text-[14px] font-[500]"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    required
                    placeholder="johndoe@gmail.com"
                    className="border border-[#E2E2E5] rounded-[4px] pl-3 h-[40px] focus:outline-none text-[#666] text-[14px] cursor-pointer"
                    // onChange={(e) => {
                    //   setChangeEmail(e.target.value);
                    // }}
                  />
                </div>

                <button
                  type="submit"
                  className="text-[#fff] inter text-[16px] font-[400] bg-[#0226BE] rounded-[4px] py-2 "
                >
                  Change Email
                </button>
              </form> */}
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default MyProfile;
